"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _emotionTheming = require("emotion-theming");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Ribbon = _interopRequireDefault(require("./Ribbon.style"));

var _class;

var Ribbon = (0, _emotionTheming.withTheme)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Ribbon, _Component);

  function Ribbon() {
    (0, _classCallCheck2.default)(this, Ribbon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Ribbon).apply(this, arguments));
  }

  (0, _createClass2.default)(Ribbon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          theme = _this$props.theme,
          style = _this$props.style;
      return _react.default.createElement("div", {
        className: _Ribbon.default.root(theme, type),
        style: style
      }, this.props.children);
    }
  }]);
  return Ribbon;
}(_react.Component)) || _class;

Ribbon.defaultProps = {
  type: 'default',
  style: {}
};
Ribbon.propTypes = {
  type: _propTypes.default.string,
  style: _propTypes.default.object
};
var _default = Ribbon;
exports.default = _default;